export const pageLoadTime = 100;
export const smoothScrollTime = 300;
